fx.ns("desktop.common.toolbar", class ToolBarFontSizeButton extends shared.stage.ToolBarAction {

    constructor(command, component, container)
    {
        super(command, component, container); 
    }

    create()
    {
        super.create();

        this.upButton = new fx.components.Image( {data : fx.get("assets").fontUpBtn, className : "up"});
        this.downButton = new fx.components.Image( {data : fx.get("assets").fontDownBtn, className : "down"} );

        this.addChild(this.upButton, { top : 0 , left : 0});
        this.addChild(this.downButton, { top : 25 , left : 0});
    }

    onReady()
    {
        super.onReady();

        this.on("click", this._onUp, this.upButton);
        this.on("click", this._onDown, this.downButton);
    }

    _onUp()
    {
        this.action("up");
    }

    _onDown()
    {
        this.action("down");
    }

});